import palette from '../palette';
import breakpoints from "../breakpoints";

export default {
  root: {
    [breakpoints.down("up")]: {
      padding: "0"
    },
    [breakpoints.down("sm")]: {
      padding: "0"
    },
    color: palette.icon,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)'
    }
  }
};
